import { humanizeTime, testLogPrefix } from "@utils/common";
export const MESSAGES = {
    apiWrapper: {
        requestFailed: (attemptNumber, retriesLeft, error) => `API request attempt ${attemptNumber} failed. ${retriesLeft} retries left. Error: ${error}`,
        allRetriesFailed: (error) => `API call failed after all retries: ${error}`,
    },
    heartbeat: {
        schedulingFailed: (error) => `Heartbeat scheduling failed: ${error}`,
        emergencyTriggered: "Emergency heartbeat triggered - no successful heartbeat in 100+ seconds",
        emergencyFailed: (error) => `Emergency heartbeat failed: ${error}`,
        failed: (error) => `Heartbeat failed: ${error}`,
        attemptFailed: (attemptNumber, retriesLeft, error) => `Heartbeat attempt ${attemptNumber} failed. ${retriesLeft} retries left. Error: ${error}`,
    },
    onBegin: {
        testData: (ciBuildId, shard) => {
            let message = `
-------Started reporting to NeetoPlaydash 🎭-------
CI Build ID: ${ciBuildId}\n`;
            shard
                ? (message += `Total shards: ${shard.total}\nCurrent shards: ${shard.current}\n`)
                : "";
            message += `${"-".repeat(50)}\n`;
            return message;
        },
    },
    onTestBegin: {
        startedTest: (title, historyId) => `${testLogPrefix(historyId)} ${title}`,
    },
    onTestEnd: {
        requestedUploadUrls: ({ title, historyId, count, duration, }) => `${testLogPrefix(historyId)} ${title} requested upload URLs for ${count} file(s) in ${duration}ms`,
        uploadedFiles: ({ title, historyId, count, duration, }) => `${testLogPrefix(historyId)} ${title} uploaded ${count} file(s) in ${duration}ms`,
        reportedTest: ({ title, status, historyId, error, isTestReported, retry, repeatEachIndex, reportingDuration, }) => [
            testLogPrefix(historyId),
            title,
            status,
            retry && `retry ${retry}`,
            repeatEachIndex && `repeat ${repeatEachIndex}`,
            isTestReported
                ? `(reported in ${reportingDuration}ms)`
                : "(not reported)",
            error && `- ${error}`,
        ]
            .filter(Boolean)
            .join(" "),
    },
    onEnd: {
        runReported: "Run completed and reported to NeetoPlaydash 🎉\n\n",
        finalStatus: ({ currentShard, status, duration, }) => {
            let message = `------------------Run completed-------------------
    Status: ${status}
    Duration: ${humanizeTime(duration !== null && duration !== void 0 ? duration : 0)}\n`;
            message =
                currentShard !== 0
                    ? message.concat(`    Shard: ${currentShard}`)
                    : message;
            return message.concat(`\n${"-".repeat(50)}\n`);
        },
        dashboardUrlHeader: "View the run in the dashboard",
    },
};
//# sourceMappingURL=messages.js.map